import Head from 'next/head';
import { EditorPage } from '../../components/pages/editorPage/EditorPage';
import { FormContextProvider } from '../../contexts/FormContext';
import { EditorType } from '../../types/EditorTypes';
import { NextPageWithAuth } from '../../types/Next';
import Script from 'next/script';

const ContentEditor: NextPageWithAuth = () => {
  return (
    <div>
      <Head>
        <title>SuperCopy | Content Editor</title>
        <meta
          name="description"
          content="Revolutionize the way we talk with one another"
        />
        <link rel="icon" href="/Supercopy_Favicon.png" />
      </Head>
      <Script
        async
        src="https://cdn.tolt.io/tolt.js"
        data-tolt="133fbbc2-e079-432c-b3be-77d5deabc9c2"
      />

      <main>
        <FormContextProvider>
          <EditorPage editorType={EditorType.CONTENT} />
        </FormContextProvider>
      </main>
    </div>
  );
};

ContentEditor.requireAuth = true;

export default ContentEditor;
